import { Banner, BlockStack, Button, InlineStack } from '@shopify/polaris';
import type { TransferClient } from './useTransferClient';
export function TransferFeedback({ client }: { client: TransferClient }) {
  return (
    <BlockStack gap="200">
      {client.error && <Banner tone="critical">{client.error}</Banner>}
      {client.blocked && !client.pending && <Button onClick={() => void client.retry()}>Check saved actions again</Button>}
      {client.pending && (
        <Banner tone="warning">
          <BlockStack gap="300">
          <p>
            {client.busy
              ? 'Saving the reviewed transfer action…'
              : 'This save has an unknown result. The exact action stays saved after the browser closes. Return with the same account and company, then retry it before making another change.'}
          </p>
          <p>
            Saved action: {client.pending.path === '/' ? 'Create transfer' : client.pending.path}. Request:{' '}
            {client.pending.requestId}
          </p>
          <InlineStack><Button loading={client.busy} disabled={client.busy} onClick={() => void client.retry()}>
            Retry saved request
          </Button></InlineStack>
          </BlockStack>
        </Banner>
      )}
      {!client.pending && client.success && (
        <Banner tone="success">
          <BlockStack gap="300">
            <p>Saved {client.success.action} for transfer {client.success.id}.</p>
            <InlineStack><Button url={'/transfer-orders/' + client.success.id}>Open saved transfer</Button></InlineStack>
          </BlockStack>
        </Banner>
      )}
    </BlockStack>
  );
}
